import Head from "next/head";
import { MapkitProvider } from "react-mapkit";
import Config from "components/config";
import MapEmbed from "components/map";

export default function MapPage({ fallback }) {
  return (
    <Config fallback={fallback}>
      <Head>
        <title>Theme Park &amp; Attractions Map - Open Coaster</title>
      </Head>
      <div className="h-[calc(100vh-4rem)] w-screen">
        <MapkitProvider tokenOrCallback="/api/map/token">
          <MapEmbed />
        </MapkitProvider>
      </div>
    </Config>
  );
}

export async function getStaticProps() {
  const fallback = {};

  return {
    props: {
      fallback,
    },
  };
}
